<template>
  <!-- 合作案例 一口价直播 -->
  <div>
    <contenr/>
    <div class="detailContainer">
      <div class="part part1">
        <span class="topName">投后数据报告</span>
        <div class="topInfo">
          <span>订单号：{{getDrDetail.sericnum?getDrDetail.sericnum:'-'}} </span>
          <i></i>
          <span>发布时间：{{getDrDetail.release_at?getDrDetail.release_at:'-'}}</span>
        </div>
        <div class="info">
          <div class="infoItem">
            <span>结算CPM</span>
            <!-- <span>￥<i>{{getDrDetail.cpma_price?getDrDetail.cpma_price:"-"}}</i></span> -->
            <span>￥<i>{{getDrDetail.unit_price?getDrDetail.unit_price:"-"}}</i></span>
          </div>
        </div>
         <div class="content">
          <a class="backImg" :href="getDrDetail.video?getDrDetail.video.url:''" target="_blank">
              <img :src="getDrDetail.video?getDrDetail.video.head_image_uri:''" alt="">
          </a>
          <div class="contentDetail">
            <p><a :href="getDrDetail.video?getDrDetail.video.url:''" target="_blank">{{getDrDetail.video?getDrDetail.video.title:'-'}}</a></p>
          </div>
          <div class="contentRight">
            <div class="rightItem">
              <span>{{getDrDetail.video?getDrDetail.video.play:'-'}}</span>
              <i>播放量</i>
            </div>
            <div class="rightItem">
              <span>{{getDrDetail.video?getDrDetail.video.like:'-'}}</span>
              <i>点赞量</i>
            </div>
            <div class="rightItem">
              <span>{{getDrDetail.video?getDrDetail.video.comment:'-'}}</span>
              <i>评论量</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contenr from "../content";
import tools from "../../components/tools/tools.js";

export default {
  name: "Detail",
  props:[],
  data(){
    return {
      orderID:0,
      getDrDetail:{}
    }
  },
  computed:{
  },
  methods:{},
  components:{
    contenr
  },
  watch:{
    
  },
  created(){
    this.orderID = this.$route.query.id
    if(window.performance.navigation.type===0||window.performance.navigation.type===1||window.performance.navigation.type===2){
        //判断浏览器刷新行为，清除session
        let inSalesGroup=window.sessionStorage.getItem('inSalesGroup')
        let name=window.sessionStorage.getItem('name')
        window.sessionStorage.clear()
        window.sessionStorage.setItem('inSalesGroup',inSalesGroup)
        window.sessionStorage.setItem('name',name)
    }
    // 获取订单指数
    this.$api.getCooperationDetailData.getDrCpm('/'+this.orderID).then((res) => {
      let getDrDetail = res.data.data
      getDrDetail.video.head_image_uri =getDrDetail.video.head_image_uri? 'https://p3-tt.bytecdn.cn/obj/'+getDrDetail.video.head_image_uri:""
      getDrDetail.video.play= getDrDetail.video.play? tools.setW(getDrDetail.video.play):'-'
      getDrDetail.video.share = getDrDetail.video.share?tools.setW(getDrDetail.video.share):'-'
      getDrDetail.video.like = getDrDetail.video.like?tools.setW(getDrDetail.video.like):'-'
      getDrDetail.video.comment = getDrDetail.video.comment?tools.setW(getDrDetail.video.comment):'-'
      getDrDetail.video.title = getDrDetail.video.title?getDrDetail.video.title:'-'
      this.getDrDetail = getDrDetail
    })
  },
  mounted(){
  }
}
</script>

<style scoped>
  .part1 .grade{
    margin-top: 30px;
    width: 100%;
    background: #FFFFFF;
    padding: 30px;
    padding-bottom: 0;
    border-top: 1px solid #F5F5F6;
    box-sizing: border-box;
  }
  .part1 .grade .title{
    display: block;
    width: 100%;
    height: 50px;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
    border-bottom: 1px solid #F5F5F6;
  }
  .part1 .grade .title2{
    width: 100%;
    height: 65px;
    margin-top: 0;
    padding-top: 30px;
    box-sizing: border-box;
  }
  .part1 .grade .comment{
    width: 100%;
    background: #F8F8F8;
    border-radius: 6px;
    padding: 20px 30px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #888888;
    line-height: 32px;
  }

  .part1 .grade .gradeContent{
    width: 100%;
    height: 230px;
  }
  .part1 .grade .gradeContent .scort{
    padding-left: 360px;
    height: 60px;
    box-sizing: border-box;
  }
  .part1 .grade .gradeContent .scort>>>.el-rate__icon{
    font-size: 60px;
  }
  .part1 .grade .gradeContent .scort>>>.el-rate__text{
    font-size: 40px;
  }
  .part1 .grade .gradeContent .tags{
    margin-top: 30px;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 50px;
  }
  .part1 .grade .gradeContent .tags span{
    padding: 12px 20px;
    margin: 0 10px;
    font-size: 16px;
    background: #FFF2EB;
    border-radius: 6px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FF6F28;
    line-height: 32px;
  }
  .part1 .grade .gradeContent .tags2{
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    padding: 0 120px;
    box-sizing: border-box;
    
  }

  .part1 .grade .gradeContent .tags2 .tagItem{
    margin-top: 40px;
    width: 260px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem span:nth-of-type(1){
    float: left;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #666666;
    line-height: 36px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem span:nth-of-type(2){
    float: left;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FF9A16;
    line-height: 36px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem img{
    float: left;
    display: inline-block;
    width: 36px;
    height: 36px;
    margin-left: 17px;
    margin-right: 11px;
  }

  .part1Echar1Nodata{
    position: absolute;
    width: 1170px;
    height: 430px;
    margin-top: 20px;
    box-sizing: border-box;
    padding-top: 140px;
    background: #fff;
    z-index: 9;
  }
  .part1Echar2Nodata{
    position: absolute;
    width: 1170px;
    height: 430px;
    margin-top: 20px;
    box-sizing: border-box;
    padding-top: 140px;
    background: #fff;
    z-index: 9;
  }
  .part1Echar2Nodata{
    position: absolute;
    width: 1170px;
    height: 450px;
    margin-top: 20px;
    box-sizing: border-box;
    padding-top: 140px;
    background: #fff;
    z-index: 9;
  }
  .noData{
    margin: auto;
    text-align: center;
    color: #999;
  }
  .noData img{
    display: block;
    margin: auto;
    margin-bottom: 30px;
  }

  .detailContainer .part{
    width: 100%;
    padding: 30px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
  }
  .detailContainer .part1{
    overflow: hidden;
  }
  .part1 .topName{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #666666;
  }
  .part1 h3{
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .part1 .topInfo{
    width: 100%;
    padding: 20px 0;
    border-bottom: 1px solid #EAEAEA;
  }
  .part1 .topInfo span{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .part1 .topInfo i{
    display: inline-block;
    width: 1px;
    height: 10px;
    margin: 0 14px;
    background: #EAEAEA;
  }
  .part1 .content{
    width: 100%;
    height: 100px;
    margin-top: 30px;
  }
  .part1 .content .backImg{
    float: left;
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
  }
  .part1 .content .backImg::before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .3);
  }
  .part1 .content .backImg::after{
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 40px;
    height: 40px;
    margin: auto;
    background: url("./images/icon_play.png") no-repeat center;
    background-size: cover;
  }
  .part1 .content .backImg img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .part1 .content .contentDetail{
    float: left;
    width: 260px;
    margin-left: 30px;
  }
  .part1 .content .contentDetail a{
    display: block;
  }
  .part1 .content .contentDetail p a{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
  }
  .part1 .content .contentDetail span a{
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .part1 .content .contentRight{
    float: right;
    margin-top: 36px;
  }
  .part1 .content .contentRight .rightItem{
    float: left;
    width: 140px;
    height: 48px;
    padding-left: 30px;
    border-right: 1px solid #F0F0F0;
    box-sizing: border-box;
  }
  .part1 .content .contentRight .rightItem:nth-last-of-type(1){
    border: 0;
  }
  .part1 .content .contentRight .rightItem span{
    display: block;
    margin-bottom: 10px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .part1 .content .contentRight .rightItem i{
    display: block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #666666;
  }
  .part1 .index{
    width: 1200px;
    height: 124px;
    margin-top: 40px;
    margin-left: -30px;
    padding-left: 30px;
    background: #FFFAF7;
    box-sizing: border-box;
  }
  .part1 .index .progress1{
    float: left;
    position: relative;
    width: 64px;
    height: 64px;
    margin-top: 30px;
  }
  .part1 .index .progress1 i{
    position: absolute;
    top:0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    line-height: 64px;
    text-align: center;
    font-size: 28px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .part1 .index span:nth-of-type(1){
    float: left;
    line-height: 124px;
    margin-left: 30px;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part1 .index .more{
    float: left;
    margin-top: 50px;
    margin-left: 16px;
    width: 116px;
    height: 24px;
    background: #F4F4F5;
    border-radius: 2px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
    text-align: center;
  }
  .part1 .index .more u{
    color: #333;
    margin: 0 3px;
    line-height: 24px;
  }
  .part1 .listItem{
    float: left;
    width: 530px;
    height: 240px;
    margin-right: 80px;
    padding-top: 50px;
    box-sizing: border-box;
  }
  .part1 .listItem:nth-of-type(2n){
    margin-right: 0;
  }
  .part1 .listItem .listTitle{
    float: left;
    width: 50%;
    height: 50px;
    margin-left: 20px;
  }
  .part1 .listItem .listTitle span{
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part1 .listItem .listTitle .more{
    margin-top: 3px;
  }
  .part1 .listItem .toWhere{
    float: right;
    width: 100px;
    height: 34px;
    background: #FF5C00;
    border-radius: 4px;
    font-size: 15px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 34px;
    text-align: center;
  }
  .part1 .listItem ul{
    width: 100%;
    height: 42px;
    margin-top: 90px;
    padding-left: 0;
  }
  .part1 .listItem ul li{
    float: left;
    width: 110px;
    height: 100%;
    margin-left: 20px;
    border-right: 1px solid #F0F0F0;
    box-sizing: border-box;
  }
  .part1 .listItem ul li:nth-last-of-type(1){
    border-right: 0;
  }
  .part1 .listItem ul li span{
    display: block;
    margin-bottom: 4px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .part1 .listItem ul li i{
    display: block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #666666;
  }
  .part1 .listItem .listBottom .bottomTitle{
    display: block;
    margin-top: 90px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .part1 .listItem .listBottom .bottomContent{
    width: 100%;
    height: 50px;
    margin-top: 24px;
  }
  .part1 .listItem .listBottom .bottomContent img{
    float: left;
    width: 50px;
    height: 50px;
  }
  .part1 .listItem .listBottom .bottomContent .bottomOther{
    float: left;
    width: 80%;
    margin-left: 20px;
  }
  .part1 .listItem .listBottom .bottomContent .bottomOther i{
    display: block;
    margin-bottom: 9px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .part1 .listItem .listBottom .bottomContent .bottomOther u{
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .part1 .listItem .listBottom .bottomContent .bottomOther span{
    display: inline-block;
    height: 26px;
    margin-right: 10px;
    margin-bottom: 6px;
    padding: 0 10px;
    line-height: 26px;
    background: #F4F4F5;
    border-radius: 2px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .part1 .listItem .listBottom .analysis{
    width: 90%;
    height: 60px;
    margin-top: 20px;
  }
  .part1 .listItem .listBottom .analysis .analysisItem{
    float: left;
  }
  .part1 .listItem .listBottom .analysis .analysisItem span{
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .part1 .listItem .listBottom .analysis .analysisItem i{
    position: relative;
    display: block;
    background: #DDDDDD;
    width: 100%;
    height: 6px;
    margin: 7px 0;
    box-sizing: border-box;
  }
  .part1 .listItem .listBottom .analysis .analysisItem i::after{
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 4px;
    height: 6px;
    background: #fff;
  }
  .part1 .listItem .listBottom .analysis .analysisItem:nth-of-type(1) i{
    background: #31C270;
  }
  .part1 .listItem .listBottom .analysis .analysisItem:nth-of-type(2) i{
    background: #FF823B;
  }

    
  .detailContainer>>>.el-tabs__nav-wrap::after{
    background-color:transparent;
    border-bottom: 1px solid #F5F5F6;
  }
  .detailContainer>>>.el-tabs__item{
    color:#999;
  }
  .detailContainer>>>.el-tabs__item.is-active{
    color: #FF5C00;
  }
  .detailContainer>>>.el-tabs__active-bar{
    background-color:#FF5C00;
  }

  .partTitle {
    width: 100%;
    height: 80px;
  }
  .partTitle .partTitleLeft{
    float: left;
    width: 60%;
  }
  .partTitle .partTitleLeft i{
    float: left;
    width: 1px;
    height: 10px;
    margin: 15px 14px 0;
    background: #EAEAEA;
  }
  .partTitle .partTitleLeft .partTitleLeftTit{
    display: block;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .partTitle .partTitleLeft p{
    float: left;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .partTitle .progress{
    float: right;
  }
  .part .hr{
    width: 1200px;
    height: 1px;
    margin-left: -30px;
    border-bottom: 1px solid #F5F5F6;
  }
  .partTitle .more{
    float: right;
    width: auto;
    padding: 0 4px;
    margin-top: 13px;
    margin-right: 30px;
  }
  .ItemContainer{
    float: left;
    margin-top: 30px;
    margin-right: 30px;
    width: 554px;
  }
  .ItemContainer .ItemTitle{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }

  .title2{
    display: block;
    margin-top: 30px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .more{
    display: block;
    width: 128px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background: #F4F4F5;
    border-radius: 2px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .more em{
    color: #333;
    font-style: normal;
    margin: 0 3px;
  }
  .progress{
    float: left;
    position: relative;
    width: 50px;
    height: 50px;
  }
  .progress i{
    position: absolute;
    top:0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .clear:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .clear {
    *zoom: 1;
  }
  .detailContainer{
    width: 1200px;
    margin: 20px auto;
  }
  
  .hotword {
      position: relative;
      margin-top: 30px;
      margin-left: 90px;
      width: 340px;
      height: 260px;
  }
  .hotword  span{
      position: absolute;
      font-size: 16px;
      font-family: OPPOSans;
      font-weight: 500;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(1){
      top: 80px;
      left: 80px;
      font-size: 60px;
      color: #FF5C00;
  }
  .hotword  span:nth-of-type(2){
      top: 54px;
      left: 100px;
      font-size: 24px;
      color: #FF5C00;
  }
  .hotword  span:nth-of-type(3){
      top: 56px;
      left: 200px;
      font-size: 20px;
      color: #FFA555;
  }
  .hotword  span:nth-of-type(4){
      top: 160px;
      left: 110px;
      font-size: 20px;
      color: #FFA555;
  }
  .hotword  span:nth-of-type(5){
      top: 180px;
      left: 160px;
      font-size: 20px;
      color: #FF5C00;
  }
  .hotword  span:nth-of-type(6){
      top: 160px;
      left: 220px;
      font-size: 18px;
      color: #FFA555;
  }
  .hotword  span:nth-of-type(7){
      top: 30px;
      left: 120px;
      font-size: 16px;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(8){
      top: 100px;
      left: 10px;
      font-size: 14px;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(9){
      top: 130px;
      left: 26px;
      font-size: 14px;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(10){
      top: 200px;
      left: 80px;
      font-size: 14px;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(11){
      top: 200px;
      left: 240px;
      font-size: 14px;
      color: #38A1FF;
  }
  .info{
    width: 100%;
    height: 160px;
    padding-left: 500px;
    box-sizing: border-box;
  }
  .info .infoItem{
    float: left;
    margin-top: 50px;
  }
  .info .infoItem:nth-of-type(1){
    margin-right: 20px;
  }
  .info .infoItem span{
    display: block;
    width: 160px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    line-height: 36px;
    margin-bottom: 20px;
    text-align: center;
  }
  .info .infoItem span:nth-of-type(2){
    color: rgb(255, 153, 0);
  }
  .info .infoItem span i{
    display: inline-block;
    margin-right: 4px;
    font-size: 36px;
    color: rgb(255, 153, 0);
  }


</style>